import React, { FC, useContext } from 'react';

import Snackbar from '@material-ui/core/Snackbar';

import { GlobalContext } from '../../store';

import IconClose from '../../assets/icons/close.svg';
import { AlertMessage } from './AlertMessage';

const Notification: FC = () => {
  const {
    actions: {
      notifications: { close: closeNotification }
    },
    notifications: {
      open,
      message: { type, text },
      alert: { club, date }
    }
  } = useContext(GlobalContext);

  const closeSnackbar = () => closeNotification();

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={!!open}
      autoHideDuration={6000}
      onClose={closeNotification}
      ContentProps={{
        'aria-describedby': 'message-id'
      }}
      className={`snack -${open === 'alert' ? 'alert' : type}`}
      message={
        <div id="message-id">
          {open === 'alert' ? (
            <AlertMessage club={club} date={date} />
          ) : (
            <div className="">{text.toString()}</div>
          )}

          <img alt="Close" className="icon-close" onClick={closeSnackbar} src={IconClose} />
        </div>
      }
    />
  );
};

export default Notification;
